export async function compressImageToBase64(
  file: File,
  maxWidth: number,
  maxHeight: number,
  quality: number,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>): void => {
      const img = new Image();

      if (typeof event.target?.result === 'string') {
        img.src = event.target.result;
      } else {
        reject('Invalid image data');
        return;
      }

      img.onload = (): void => {
        let {width, height} = img;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height);
          height = maxHeight;
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Failed to create canvas context');
          return;
        }

        ctx.drawImage(img, 0, 0, width, height);

        try {
          const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
          resolve(compressedBase64);
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = (error: string | Event): void => {
        reject(error);
      };
    };

    reader.onerror = (error: ProgressEvent<FileReader>): void => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}